import type { ActionFunctionArgs } from '@remix-run/node';
import { createNewDesignBoard } from '@modules-rocco/design-board/api/create-new-design-board.server';
import { ServerErrorResponse } from '@modules/root/graphql/responses';

export const ACTION_CREATE_DESIGN_BOARD = '/actions/create-design-board';

interface CreateDesignBoardFormData {
    title: string;
    description: string;
    isPrivate: boolean;
}

export const action = async ({ request, context }: ActionFunctionArgs) => {
    const formData = await request.formData();
    const formObj = Object.fromEntries(
        formData
    ) as unknown as CreateDesignBoardFormData;

    if (!formObj.title) {
        return new ServerErrorResponse('Title is required');
    }

    try {
        return await createNewDesignBoard(formObj, context);
    } catch (error) {
        // If it's a Response object, return it directly
        if (error instanceof Response) {
            return error;
        }

        return new ServerErrorResponse(
            error instanceof Error
                ? error.message
                : 'Failed to create design board'
        );
    }
};
